import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as NewNotificationLogo } from "assets/img/notification-new.svg";
import { ReactComponent as NoNotificationLogo } from "assets/img/notification-no.svg";

NotificationIcon.propTypes = {
    notificationCount: PropTypes.number
};

function NotificationIcon({notificationCount = 0}) {
    if (notificationCount > 0) {
        return  <NewNotificationLogo />
    } else {
        return  <NoNotificationLogo />
    }
}

export default NotificationIcon;
